import { isInternalPortfolioProject } from '@fiverr-private/portfolio';
import { PortfolioListType } from '../../../context/PortfolioListContext';

export const extractExternalProjects = (projects: NonNullable<PortfolioListType>) =>
    projects.filter(
        ({ source, internalProjectDetails }) => !isInternalPortfolioProject(source, internalProjectDetails)
    );
